module.exports = __webpack_public_path__ + "img/public/siteImages/dashBoardHandIcon.png?906125ad";